import { lazy } from 'react';

export const ViewPageLazy = lazy(() => import('./ViewPage'));
